import React, { useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  Active,
  Delete,
  Invoice,
  LoginAs,
  Show,
  SmsStatus,
  Suspend,
} from "../../../Constant";
import { useNavigate } from "react-router";
import {
  getDataWithToken,
  postDataWithoutToken,
  postDataWithToken,
  postMasterToken,
} from "../../../Utils/restUtils";
import {
  activateCompany,
  addSetupCost,
  checkPlanLimit,
  getclientpackage,
  getOtp,
  OperatorUrl,
  postActiveCustomer,
  postSmsStatus,
  postSuspendCustomer,
  suspendCompany,
} from "../../../CommonURL";
import SweetAlert from "sweetalert2";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import Popup from "../../Common/Popup/Popup";
import PopupDays from "./PopupDays";
import DeleteCompany from "./DeleteCompany";
import { Typeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

const CompanyActionCell = ({ row, deleteCompany, companyData }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [packageOptions, setPackageOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [planError, setPlanError] = useState(false);
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const viewForm = (row) => {
    setModal(!modal);
  };

  const redirectToLogin = async (row) => {
    setLoading(true);
    const userId = { user_id: row.id };
    const token = await postDataWithoutToken(getOtp, userId);
    if (token.data.status === true) {
      setLoading(false);
      const url =
        row.app_url + `/loading?user_id=${row.id}&token=${token.data.data}`;
      window.open(url, "_blank");
    }
    setLoading(false);
  };

  const SmsStatusChange = async (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "You want to change the status of SMS!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      setLoading(true);
      if (result.value) {
        const payload = {
          company_id: data.CompanyId,
          sms_enable: data.Sms === "no" ? "yes" : "no",
        };
        const packageRemove = await postDataWithToken(postSmsStatus, payload);
        if (packageRemove.data.status === true) {
          SweetAlert.fire(
            "Status Changed!",
            "Your status has been changed.",
            "success",
          );
          companyData();
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
          setLoading(false);
        }
      } else {
        // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }
      setLoading(false);
    });
  };

  const suspendCustomer = async (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "You want to suspend customer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      setLoading(true);
      if (result.value) {
        const payload = {
          company_id: data.CompanyId,
          industry_type_id: data.IndustryId,
        };
        const packageRemove = await postDataWithToken(suspendCompany, payload);
        if (packageRemove.data.status === true) {
          SweetAlert.fire(
            "Status Changed!",
            "Your status has been changed.",
            "success",
          );
          companyData(1);
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
          setLoading(false);
        }
      } else {
        // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }
      setLoading(false);
    });
  };
  const loadPackages = async (industryId, userId) => {
    try {
      const Postreq = {
        industry_type_id: industryId,
        user_id: userId,
      };
      const res = await postMasterToken(getclientpackage, Postreq);
      if (res?.data?.status === true) {
        const transformed = res.data.data.packages.map((pkg) => ({
          label: pkg.name,
          value: pkg.id,
          fullData: pkg,
        }));

        setPackageOptions(transformed);
      }
    } catch (err) {
      toast.error("Failed to load packages");
    }
  };
  const handleCancel = () => {
    setShowPlanModal(false);
  };
  const checkPlan = async (selectedPackageId) => {
    try {
      const url = `${checkPlanLimit}?company_id=${row.CompanyId}&user_id=${row.id}&selected_package_id=${selectedPackageId}`;

      const response = await getDataWithToken(url);

      console.log(response);

      if (response?.data !== true) {
        setPlanError(true);

        toast.error(response?.message || "Plan check failed");
      } else {
        setPlanError(false);
      }

      return response?.data;
    } catch (err) {
      console.error(err);
      setPlanError(false);
      toast.error("Something went wrong");
    }
  };
  const handleConfirmPlan = async () => {
    if (!selectedPlan) {
      toast.error("Please select a subscription plan");
      return;
    }

    if (!selectedUser) {
      toast.error("User data missing");
      return;
    }

    const requestBody = {
      package_id: selectedPlan.value,
      company_id: selectedUser.company_id,
      user_id: selectedUser.user_id,
      created_admin: "1",
    };

    try {
      const response = await postDataWithToken(addSetupCost, requestBody);
      if (response?.data?.status === true) {
        if (response?.data?.data === "free") {
          navigate(`${process.env.PUBLIC_URL}/subscriptions/active-sub`);
        } else {
          navigate(
            `${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?order_id=${response?.data?.data?.order_id}`,
          );
        }
      } else {
        toast.error("Try again");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setShowPlanModal(false);
    }
  };

  const activeCustomer = async (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "You want to active customer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      setLoading(true);
      if (result.value) {
        const payload = {
          company_id: data.CompanyId,
          industry_type_id: data.IndustryId,
        };
        const packageRemove = await postDataWithToken(activateCompany, payload);
        if (packageRemove.data.status === true) {
          SweetAlert.fire(
            "Status Changed!",
            "Your status has been changed.",
            "success",
          );
          companyData(1);
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
          setLoading(false);
        }
      } else {
        // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }
      setLoading(false);
    });
  };

  const companyDelete = async () => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this company!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      setLoading(true);
      if (result.value) {
        setModal(true);
      } else {
        // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }
      setLoading(false);
    });
  };
  const redirectToInvoice = (row) => {
    navigate(`/billing/invoice-list?company_id=${row.CompanyId}`);
  };

  const redirectTopackage = (row) => {
    setSelectedUser({
      user_id: row.id,
      company_id: row.CompanyId,
      industry_id: row.IndustryId,
    });

    loadPackages(row.IndustryId, row.id);
    setShowPlanModal(true);
  };
  return (
    <>
      {loading && <Transparentspinner />}
      <Popup isOpen={modal} title={`Company ` + Delete} toggler={viewForm}>
        <DeleteCompany
          id={row.CompanyId}
          modal={setModal}
          list={companyData || (() => {})}
        />
      </Popup>
      <Modal isOpen={showPlanModal} centered backdrop="static">
        <ModalHeader>Choose Subscription Plan</ModalHeader>

        <ModalBody>
          <Label className="form-label">Subscription Plan</Label>
          <Input
            type="select"
            value={selectedPlan?.value ?? ""}
            onChange={async (e) => {
              const selected = packageOptions.find(
                (item) => String(item.value) === e.target.value,
              );

              setSelectedPlan(selected || null);

              if (selected) {
                await checkPlan(selected.value);
              }
            }}
          >
            <option value="">-- Select a package --</option>

            {packageOptions.map((pkg) => (
              <option key={pkg.value} value={pkg.value}>
                {pkg.label}
              </option>
            ))}
          </Input>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handleCancel}>
            Back
          </Button>

          <Button
            color="primary"
            onClick={handleConfirmPlan}
            disabled={!selectedPlan || planError}
          >
            Continue
          </Button>
        </ModalFooter>
      </Modal>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          {/* <DropdownItem style={toggleStyle} onClick={() => redirectToEditForm(row)}>{Edit}</DropdownItem> */}
          <DropdownItem
            style={toggleStyle}
            onClick={() => SmsStatusChange(row)}
          >
            {SmsStatus}
          </DropdownItem>
          <DropdownItem
            style={toggleStyle}
            onClick={() => redirectToLogin(row)}
          >
            {LoginAs}
          </DropdownItem>
          {row.Status === "suspended" && (
            <DropdownItem
              style={toggleStyle}
              onClick={() => activeCustomer(row)}
            >
              {Active}
            </DropdownItem>
          )}

          {row.Status === "active" && (
            <DropdownItem
              style={toggleStyle}
              onClick={() => suspendCustomer(row)}
            >
              {Suspend}
            </DropdownItem>
          )}
          {row.planType === "paid" && (
            <DropdownItem
              style={toggleStyle}
              onClick={() => redirectToInvoice(row)}
            >
              {" "}
              {Invoice}
            </DropdownItem>
          )}
         
            <DropdownItem
              style={toggleStyle}
              onClick={() => redirectTopackage(row)}
            >
              Plan Upgrade
            </DropdownItem>
        
          {/* <DropdownItem
            style={{
              padding: "10px 20px",
              color: "red",
              opacity: "0.8",
              fontSize: "14px",
              margin: "0",
            }}
            onClick={() => companyDelete()}
          >
            Company {Delete}
          </DropdownItem>
          <DropdownItem
            style={{
              padding: "10px 20px",
              color: "red",
              opacity: "0.8",
              fontSize: "14px",
              margin: "0",
            }}
            onClick={() => deleteCompany(row.id)}
          >
            Customer {Delete}
          </DropdownItem> */}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default CompanyActionCell;
